export type CaInfo = {
	ca_hash: string | null;
	hash: string | null;
	ca_name: string;
	ca_serial: string;
	active: boolean;
};

export function isCaInfo(value: unknown): value is CaInfo {
	if (typeof value !== 'object' || value === null) return false;
	const v = value as Record<string, unknown>;
	return (
		(typeof v.ca_hash === 'string' || v.ca_hash === null) &&
		(typeof v.hash === 'string' || v.hash === null) &&
		typeof v.ca_name === 'string' &&
		typeof v.ca_serial === 'string' &&
		typeof v.active === 'boolean'
	);
}
